var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTetInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "icon",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.67761C6.48 2.67761 2 7.15761 2 12.6776C2 18.1976 6.48 22.6776 12 22.6776C17.52 22.6776 22 18.1976 22 12.6776C22 7.15761 17.52 2.67761 12 2.67761ZM12 17.6776C11.45 17.6776 11 17.2276 11 16.6776V12.6776C11 12.1276 11.45 11.6776 12 11.6776C12.55 11.6776 13 12.1276 13 12.6776V16.6776C13 17.2276 12.55 17.6776 12 17.6776ZM13 8.67761C13 9.2299 12.5523 9.67761 12 9.67761V9.67761C11.4477 9.67761 11 9.2299 11 8.67761V8.67761C11 8.12533 11.4477 7.67761 12 7.67761V7.67761C12.5523 7.67761 13 8.12533 13 8.67761V8.67761Z",
    fill: "#99A0AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTetInfo);
export default __webpack_public_path__ + "static/media/tet-info.643e67ed494671b3774dc6f9c36a0b46.svg";
export { ForwardRef as ReactComponent };